module.exports = __webpack_public_path__ + "img/08.f3b264eb.png";